import { instance } from '@shared/api/config';
import { AccountReportCategory } from '@shared/types/osi/accountReports';
import { CORE_PATH } from '@shared/api/paths';

const MAIN_PATH = 'AccountReports';

export const getAccountReportsCategories = async (): Promise<AccountReportCategory[]> =>
  instance.get(`${CORE_PATH}/${MAIN_PATH}/categories`);

export const getReportFormData = async (id: number) =>
  instance.post(`${CORE_PATH}/${MAIN_PATH}/${id}/monthly-form-data`);
